import React, { forwardRef, ReactNode } from 'react';
import type { DialogTitleProps } from '@mui/material';
import { DialogTitle as DialogTitleMUI } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';

import { omitUndefinedProps } from '@/mui/helpers';

import IconButton from '../IconButton/IconButton';

type Props = {
  onClose?: () => null;
  closeIcon?: ReactNode;
};

// todo: re-check condition props.onClose || props.closeIcon
const DialogTitle = forwardRef<HTMLSpanElement, DialogTitleProps & Props>((props, ref) => (
  <DialogTitleMUI {...omitUndefinedProps(props)} ref={ref}>
    {(props.onClose || props.closeIcon) && (
      <IconButton size="medium" onClick={props.onClose}>
        {props.closeIcon ?? <CloseRounded />}
      </IconButton>
    )}
    {props.children}
  </DialogTitleMUI>
));

DialogTitle.displayName = 'DialogTitle';

export default DialogTitle;
